import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import autoCompletePlayerHOC from '../../hoc/autoCompletePlayerHOC';

const AutoCompletePlayer = ({ searchText, data: players, handleOnClose, handleUpdateInput, onNewRequest }) => (
    <AutoComplete
        floatingLabelText="Player name"
        fullWidth
        openOnFocus
        searchText={searchText}
        filter={AutoComplete.caseInsensitiveFilter}
        dataSource={players}
        dataSourceConfig={{ text: 'name', value: 'id' }}
        onClose={handleOnClose}
        onUpdateInput={handleUpdateInput}
        onNewRequest={onNewRequest}
    />
);

AutoCompletePlayer.propTypes = {
    searchText: PropTypes.string,
    data: PropTypes.array.isRequired,
    onNewRequest: PropTypes.func.isRequired,
    handleOnClose: PropTypes.func.isRequired,
    handleUpdateInput: PropTypes.func.isRequired,
};

export default autoCompletePlayerHOC(AutoCompletePlayer);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/PlayerPicker/AutoCompletePlayer.js
 **/